module.exports = __webpack_public_path__ + "static/media/commerical-2.f26ccaa7.jpg";